


























import { Component, Prop, Vue } from 'vue-property-decorator';
import Header from "@/commonComponents/header/header.vue";
import PagePreview from './pagePreview/pagePreview.vue';
import TopController from './topController/topController.vue';
import TopControllerInsertion from './topControllerInsertion/topControllerInsertion.vue';
import RightController from './rightController/rightController.vue';
import RightControllerInsertion from './rightControllerInsertion/rightControllerInsertion.vue';
import PageController from '@/commonComponents/pageController/pageController.vue';
import DisplayController from './displayController/displayController.vue';
import ContextMenu from '@/commonComponents/contextMenu/contextMenu.vue';
import FileOpen2 from '@/commonComponents/fileOpen2/fileOpen2.vue';
import DeleteDesign from './deleteDesignModal/deleteDesignModal.vue';
import FontConvertModal from "@/commonComponents/alertModal/fontConvertModal/fontConvertModal.vue";
import Tutorial from "../tutorial/tutorial.vue";
import License from "../top2/mainContents/license/license.vue";
import LoadingScreen from "@/commonComponents/loadingScreen/loadingScreen.vue"
import DiscardConfirmation from "@/commonComponents/alertModal/discardConfirmationModal/discardConfirmationModal.vue";
import SaveAttentionAlert from '@/commonComponents/alertModal/saveAttentionAlert/saveAttentionAlert.vue';

import * as def from '@/definitions'
// TODO document2
import { Const } from '@/const';
import { Document } from '@/model/document2/document';
import { Page } from '@/model/document2/page/page';
import { Design } from '@/model/document2/page/surface/design/design';
import { ClipboardManager } from "@/model/clipboardManager/clipboardManager";

// Command
import { CopyDesignCommand } from '@/commands/copyDesignCommand';
import { CopyMultiDesignCommand } from '@/commands/copyMultiDesignCommand';
import { DeleteDesignCommand } from '@/commands/deleteDesignCommand';
import { NewPageCommand } from '@/commands/newPageCommand';
import { DeletePageCommand } from '@/commands/deletePageCommand';
import { NewDesignCommand } from '@/commands/newDesignCommand';
import { DuplicateDesignCommand } from '@/commands/duplicateDesignCommand';
import { RotateDocumentCommand } from '@/commands/rotateDocumentCommand';

import { FileConverter } from '@/label_convert/fileConverter';

// Helper
import { FileHelper } from '@/helper/fileHelper'
import { EncryptionHelper } from "@/helper/encryptionHelper"
import { ArrayHelper } from "@/helper/arrayHelper"
import { ShortcutManager } from '@/model/shortcutManager/shortcutManager';
import { InsertionHelper } from '@/helper/insertionHelper';
import { NameHelper } from '@/helper/nameHelper';
import { DocumentHelper } from '@/helper/documentHelper';
import { CookieHelper } from "@/helper/cookieHelper";
import { DebugHelper } from "@/helper/debugHelper";
import { FontHelper } from '@/helper/fontHelper';
import { LogHelper } from "@/helper/logHelper";
import { UserAgentHelper } from "@/helper/userAgentHelper";
import { NativeHelper } from "@/helper/nativeHelper";
import { StringHelper } from "@/helper/stringHelper";

import { InitializeHelper } from "@/helper/initializeHelper";
import { Product } from '@/data/productCategory/product/product';
import { Paper } from '@/data/productCategory/product/paper/paper';

import { CloudAccount } from "@/cloudAccount/cloudAccount";

import { FontManager } from '@/model/fontManager/fontManager';
import platform from '@/helper/platform';

import RecommendApi from "@/api/gateways/recommend-api";
import RecommendBannerProps from "@/components/recommend/RecommendBannerProps";
import AskConvert3dTextAlertModal from "@/commonComponents/alertModal/askConvert3dTextAlertModal/askConvert3dTextAlertModal.vue";

@Component({
    components: {
        Header,
        PagePreview,
        TopController,
        TopControllerInsertion,
        RightController,
        RightControllerInsertion,
        PageController,
        DisplayController,
        ContextMenu,
        FileOpen2,
        DeleteDesign,
        FontConvertModal,
        Tutorial,
        License,
        LoadingScreen,
        DiscardConfirmation,
        SaveAttentionAlert,
        AskConvert3dTextAlertModal
    },
})
export default class LayoutEditor extends Vue
{
    // ドキュメントのロード終了フラグ
    private isLoadedDocument = false;
    private get isElectron() { return UserAgentHelper.isElectron(); }

    private get currentTab() { return "/LayoutEditor"; }

    private get paperInfoText() { return DocumentHelper.getPaperInfoText(this.currentDocument); }

    // 差し込み用ページ
    private insertionPage : Page | null = null;
    private insertionMaxPage : number = 0;
    private updatePage()
    {
        this.insertionMaxPage = InsertionHelper.calcPageCount(this.currentDocument);
        // ページ数が減って、カレントページが最大ページを超えた場合の補正
        if(this.insertionMaxPage - 1 < this.currentDocument.currentPageIndex) this.currentDocument.currentPageIndex = this.insertionMaxPage - 1;
        this.insertionPage = null;
        this.insertionPage = InsertionHelper.createPage(this.currentDocument, this.currentDocument.currentPageIndex);
    }
    private disposePage()
    {
        this.insertionPage = null;
    }

    // ドラッグ中のアイテムポジション
    private draggingItemPosition : number = -1;
    // ドラッグ中の素材
    private draggingMaterialIndex : number = -1;

    // ズーム
    private zoomScale : number = 100;
    private isAutoZoom : boolean = true;

    // チュートリアルフラグ
    isTutorial = false;
    // 利用規約許諾フラグ
    isLicense = false;

    // フォントロードフラグ
    private isFontLoaded = false;

    // ショートカットキー、およびメニューのID
    static readonly MENU_COMMAND_UNDO = "layout_editor_undo";
    static readonly MENU_COMMAND_REDO = "layout_editor_redo";
    static readonly MENU_SAVE_DOCUMENT = "layout_editor_save_document";
    static readonly MENU_COMMAND_ZOOM_100 = "layout_editor_zoom_100";
    static readonly MENU_COMMAND_ZOOM_IN = "layout_editor_zoom_in";

    // 待機
    private isWaiting = false;
    private get waitingTitle() { return "処理中"; }
    private get waitingMessage() { return "処理をしています…"; }

    // ヘッダーで画面から抜ける時の処理
    private onHeaderNavigationStart(link : string)
    {
        if(link == "/DesignEditor" || link == "/PrintSetting")
        {
            // デザイン、印刷に遷移する時に処理中表示
            this.isWaiting = true;
        }
    }

    private onHeaderNavigationFinish(link : string)
    {
        // 処理中を非表示
        this.isWaiting = false;
    }

    // 遷移処理
    // showWait : 待機モーダルを表示する
    // callback : pushするときの処理
    private goLink(link : string, showWait : boolean = false, callback : (() => void) | null = null)
    {
        if(showWait)
        {
            this.isWaiting = true;
            setTimeout(() =>
            {
                this.isWaiting = false;
                if(callback != null) { callback(); }
                this.$router.push(link);
            }, 50);
        }
        else
        {
            if(callback != null) { callback(); }
            this.$router.push(link);
        }
    }

    private get clipboardManager() : ClipboardManager
    {
        return this.$store.getters.clipboardManager;
    }

    private mounted()
    {
        this.loadRecommendBanners();
        if(this.$store.getters.applicationState.preloadDocument != null)
        {
            // プリロード中のドキュメントがある場合はドキュメントセット
            this.updateProductAndPageDataFromDocument(this.$store.getters.applicationState.preloadDocument, () =>
            {
                this.$store.dispatch("setDocument", this.$store.getters.applicationState.preloadDocument);
                this.isWaiting = true;
                if(this.$store.getters.applicationState.preloadDocument.useInsertion)
                {
                    // 差し込みの場合はフロー変更
                    this.$store.getters.applicationState.flowMode = 3;
                }
                else
                {
                    this.$store.getters.applicationState.flowMode = 0;
                }
                setTimeout(() =>
                {
                    let productId = this.$store.getters.applicationState.preloadDocument.productId;
                    let paperCode = this.$store.getters.applicationState.preloadDocument.paperCode;
                    this.isWaiting = false;
                    this.isLoadedDocument = true;
                    this.$store.getters.applicationState.preloadDocument = null;

                    try
                    {
                        //  ファイルを開いたときにそのファイルの品番をログで送る
                        LogHelper.sendLog("100" , {
                            productId : productId,
                            code : paperCode,
                            cloud : 0
                        });

                        if(this.$store.getters.applicationState.flowMode == 3)
                        {
                            // 差し込みの場合は画面遷移
                            this.$router.push("/InsertionEditor");
                        }
                    }
                    catch(e)
                    {
                    }
                }, 10);
            });
        }
        else
        {
            this.isLoadedDocument = true;
        }

        // ショートカット登録
        this.registerShortcut();
        document.addEventListener("keydown", this.onKeyDown);

        // メッセージセンター登録
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.subscribe(this, "exec_command", this.processExecCommand);

        if(CookieHelper.getItem("license") != true){
            this.isLicense = true;
        }
        else if(this.flowMode == 0 && CookieHelper.getItem("layoutEditorTutorial") != true){
            this.isTutorial = true;
        }
        else if((this.flowMode == 1 || this.flowMode == 2) && CookieHelper.getItem("insertionLayoutEditorTutorial") != true){
            this.isTutorial = true;
        }

        // TODO 多分もういらないけど残しておく
        // Webfontロード
        FontHelper.loadWebFonts(() =>
        {
            // ロード完了
            this.isFontLoaded = true;
        }, () =>
        {
            // ロード失敗
            this.isFontLoaded = true;
        });

        if(this.currentDocument.useInsertion)
        {
            // 差し込みページ更新
            this.updatePage();
        }
    }

    private destroyed()
    {
        // ショートカット解除
        this.unregisterShortcut();
        document.removeEventListener("keydown", this.onKeyDown);

        // メッセージセンター削除
        var messageCenter = this.$store.getters.messageCenter;
        messageCenter.unsubscribe(this, "exec_command");

        if(this.currentDocument.useInsertion)
        {
            // 差し込みページ更新
            this.disposePage();
        }
    }

    // コマンド処理
    // DL版で呼び出す
    private processExecCommand(paramParent : any)
    {
        try
        {
            var command : string = paramParent.command;
            var parameter : any = paramParent.parameter;

            if(command == "new_document")
            {
                // 新規ドキュメント
                this.createNewDocument();
            }
            else if(command == "save_document_completed")
            {
                // ドキュメントの保存完了をネイティブから通知される
                if(this.isSaveModalVisible)
                {
                    // 保存モーダル表示中であれば、完了処理を行う
                    this.saveModalCompletion();
                }
                // ドキュメントのハッシュ更新
                this.currentDocument.updateHash();

                // 保存履歴送信
                LogHelper.sendLog("1000", {
                    productId : this.currentDocument.productId,
                    code : this.currentDocument.paperCode,
                    templateId : this.$store.getters.data.selectedTemplate.id,
                    cloud : 0
                });
            }
            else if(command == "import_document" || command == "load_document")
            {
                // ドキュメント読み込み
                let doc = FileHelper.loadDocumentAnyway(parameter.document);
                if(doc == null) return;
                let filePath = parameter.filePath;
                let fileName = parameter.fileName != null ? parameter.fileName : "";
                doc.currentFilePath = filePath;
                doc.openedFileName = fileName;
                let comp = () =>
                {
                    if(doc == null) return;
                    if(command == "load_document")
                    {
                        this.loadDocumentCore(doc);
                    }
                    else
                    {
                        this.updateProductAndPageDataFromDocument(doc, () =>
                        {
                            if(doc == null) return;
                            // ドキュメントの差し替え
                            this.$store.dispatch("setDocument", doc);
                            if(doc.useInsertion)
                            {
                                // 差し込みの場合はフロー変更
                                this.$store.getters.applicationState.flowMode = 3;
                                // 画面遷移
                                this.$router.push("/InsertionEditor");
                            }
                            else
                            {
                                this.$store.getters.applicationState.flowMode = 0;
                            }
                        });
                    }
                };
                // フォントコンバート対応
                FontManager.applyUnloadedFontsToDocument(doc);
                if(doc.unloadedFonts.length > 0)
                {
                    // 利用できないフォントがあった場合
                    var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                    // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                    fontConvertModal.open(doc.unloadedFonts,
                    () =>
                    {
                        comp();
                    });
                }
                else
                {
                    comp();
                }
            }
            else if(command == "import_label9_document" || command == "load_label9_document")
            {
                // ラベル9ドキュメント読み込み
                let documentBuf = parameter.document;
                let filePath = parameter.filePath;
                let fileName = parameter.fileName != null ? parameter.fileName : "";

                // zip解凍
                let Unzip = require('zlibjs/bin/unzip.min').Zlib.Unzip;
                let uz = new Unzip(documentBuf);
                let filenames = uz.getFilenames();
                if(filenames && filenames.length > 0)
                {
                    // 最初のファイル(xml)
                    let decompressed = uz.decompress(filenames[0]);
                    let documentXml = StringHelper.utf8ArrayToStr(decompressed);
                    // ファイルコンバート
                    let fileConverter = new FileConverter(this.$store.getters.fontManager);
                    let doc = fileConverter.deserializeLabel9FromXml(documentXml);
                    if(doc != null)
                    {
                        doc.currentFilePath = filePath;
                        doc.openedFileName = fileName;

                        // 完了処理
                        let completion = () =>
                        {
                            if(doc == null) return;
                            let completion2 = () =>
                            {
                                if(doc == null) return;
                                if(command == "load_label9_document")
                                {
                                    this.loadDocumentCore(doc);
                                }
                                else
                                {
                                    // ドキュメントの差し替え
                                    this.$store.dispatch("setDocument", doc);
                                    if(doc && doc.useInsertion)
                                    {
                                        // 差し込みの場合はフロー変更
                                        this.$store.getters.applicationState.flowMode = 3;
                                        // 画面遷移
                                        this.$router.push("/InsertionEditor");
                                    }
                                    else
                                    {
                                        this.$store.getters.applicationState.flowMode = 0;
                                    }
                                }
                            }

                            // ラベル屋さん9の3D文字のコンバート対応
                            if(DocumentHelper.contains3dTextLayers(doc)) {
                                (this.$refs.askConvert3dTextAlertModal as AskConvert3dTextAlertModal).open(ret => {
                                    if(doc == null) return;
                                    if(ret) {
                                        DocumentHelper.convert3dTextLayersToSimpleTextLayers(doc);
                                    }
                                    completion2();
                                })
                            } else {
                                completion2();
                            }
                        };

                        if(doc.unloadedFonts.length > 0)
                        {
                            // 利用できないフォントがあった場合
                            var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                            // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                            fontConvertModal.open(doc.unloadedFonts,
                            () =>
                            {
                                if(doc != null) { completion(); }
                            });
                        }
                        else
                        {
                            completion();
                        }
                    }
                }
            }
            else if(command == "open_paper_info")
            {
                // 用紙情報を開く
                NativeHelper.sendNativeEvent("open_external_link", { url : Const.PRODUCT_DETAIL_URL_BASE + this.currentDocument.productCode });
            }
            else if(command == "undo")
            {
                // アンドゥ
                this.undo();
            }
            else if(command == "redo")
            {
                // リドゥ
                this.redo();
            }
            else if(command == "edit_design")
            {
                // デザインの編集
                this.editDesign();
            }
            else if(command == "cut_design")
            {
                // デザインのカット
                this.cutCurrentDesign();
            }
            else if(command == "copy_design")
            {
                // デザインのコピー
                this.copyCurrentDesign();
            }
            else if(command == "paste_design")
            {
                // デザインの貼り付け
                this.pasteDesignToCurrent();
            }
            else if(command == "copy_design_horizontal")
            {
                // 横にコピー
                this.copyHorizontal();
            }
            else if(command == "copy_design_vertical")
            {
                // 縦にコピー
                this.copyVertical();
            }
            else if(command == "copy_design_all")
            {
                // 全面にコピー
                this.copyAll();
            }
            else if(command == "delete_design")
            {
                // デザインを削除
                this.showDeleteDesignModal();
                this.deleteDesignIndex = this.currentPage.currentDesignPosition;
                this.deleteUnselectDesigns = false;
            }
            else if(command == "delete_design_all")
            {
                // デザインをすべて削除
                this.showDeleteDesignModal();
                this.deleteDesignIndex = -1;
                this.deleteUnselectDesigns = false;
            }
            else if(command == "switch_auto_zoom")
            {
                // 自動ズーム切り替え
                this.switchAutoZoom();
            }
            else if(command == "change_zoom_scale_by_step")
            {
                // ズーム変更
                this.changeZoomScaleByStep(parameter.direction == "up", true);
            }
            else if(command == "save_to_cloud_document")
            {
                // クラウドへ保存
                this.$store.dispatch("setCloudOperation", this.$router.currentRoute.path);
                this.$store.dispatch("setCloudMode", "save");
                var cloudAccount = this.$store.getters.cloudAccount as CloudAccount;
                if(cloudAccount.isSignIn)
                {
                    this.$router.push("/cloud");
                }
                else
                {
                    this.$store.dispatch("setSignInToGo", "cloud");
                    this.$router.push("/signIn");
                }
            }
        }
        catch(ex)
        {
            DebugHelper.trace(ex);
        }
    }

    private registerShortcut()
    {
        // ショートカット登録
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        if(!UserAgentHelper.isElectron())
        {
            // Web版のみ
            manager.addKeyboardShortcut(LayoutEditor.MENU_COMMAND_UNDO, "ctrl", "z", () => this.executeCommand(LayoutEditor.MENU_COMMAND_UNDO), () => this.canExecuteCommand(LayoutEditor.MENU_COMMAND_UNDO));
            manager.addKeyboardShortcut(LayoutEditor.MENU_COMMAND_REDO, "ctrl + shift", "z", () => this.executeCommand(LayoutEditor.MENU_COMMAND_REDO), () => this.canExecuteCommand(LayoutEditor.MENU_COMMAND_REDO));
            manager.addKeyboardShortcut(LayoutEditor.MENU_SAVE_DOCUMENT, "ctrl", "s", () => this.executeCommand(LayoutEditor.MENU_SAVE_DOCUMENT), () => this.canExecuteCommand(LayoutEditor.MENU_SAVE_DOCUMENT));
        }
        else
        {
            // DL版のみ
            manager.addKeyboardShortcut(LayoutEditor.MENU_COMMAND_ZOOM_100, "ctrl", "1", () => this.executeCommand(LayoutEditor.MENU_COMMAND_ZOOM_100), () => this.canExecuteCommand(LayoutEditor.MENU_COMMAND_ZOOM_100));
            manager.addKeyboardShortcut(LayoutEditor.MENU_COMMAND_ZOOM_IN, "ctrl + shift", "-", () => this.executeCommand(LayoutEditor.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(LayoutEditor.MENU_COMMAND_ZOOM_IN));
            manager.addKeyboardShortcut(LayoutEditor.MENU_COMMAND_ZOOM_IN, "ctrl + shift", "=", () => this.executeCommand(LayoutEditor.MENU_COMMAND_ZOOM_IN), () => this.canExecuteCommand(LayoutEditor.MENU_COMMAND_ZOOM_IN));
        }
    }

    // メニューコマンド処理
    private canExecuteCommand(key) : boolean
    {
        var canExecute = false;
        if(key == LayoutEditor.MENU_COMMAND_UNDO)
        {
            canExecute = this.currentDocument.undoRedoManager.canUndo;
        }
        else if(key == LayoutEditor.MENU_COMMAND_REDO)
        {
            canExecute = this.currentDocument.undoRedoManager.canRedo;
        }
        else if(key == LayoutEditor.MENU_SAVE_DOCUMENT)
        {
            canExecute = true;
        }
        else if(key == LayoutEditor.MENU_COMMAND_ZOOM_100)
        {
            canExecute = true;
        }
        else if(key == LayoutEditor.MENU_COMMAND_ZOOM_IN)
        {
            canExecute = this.changeZoomScaleByStep(true, true, false);
        }

        return canExecute;
    }

    private executeCommand(key) : void
    {
        if(key == LayoutEditor.MENU_COMMAND_UNDO)
        {
            this.undo();
        }
        else if(key == LayoutEditor.MENU_COMMAND_REDO)
        {
            this.redo();
        }
        else if(key == LayoutEditor.MENU_SAVE_DOCUMENT)
        {
            this.saveDocument();
        }
        else if(key == LayoutEditor.MENU_COMMAND_ZOOM_100)
        {
            this.changeZoomScale(100, true);
        }
        else if(key == LayoutEditor.MENU_COMMAND_ZOOM_IN)
        {
            this.changeZoomScaleByStep(true, true, true);
        }
    }

    private unregisterShortcut()
    {
        // ショートカット解除
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        if(!UserAgentHelper.isElectron())
        {
            // Web版のみ
            manager.removeKeyboardShortcut(LayoutEditor.MENU_COMMAND_UNDO);
            manager.removeKeyboardShortcut(LayoutEditor.MENU_COMMAND_REDO);
            manager.removeKeyboardShortcut(LayoutEditor.MENU_SAVE_DOCUMENT);
        }
        else
        {
            // DL版のみ
            manager.removeKeyboardShortcut(LayoutEditor.MENU_COMMAND_ZOOM_100);
            manager.removeKeyboardShortcut(LayoutEditor.MENU_COMMAND_ZOOM_IN);
        }
    }

    private onKeyDown(event)
    {
        // ショートカット実行
        var manager : ShortcutManager = this.$store.getters.shortcutManager;
        manager.doKeyboardShortcutIfNeeded(event);
    }

    public get currentDocument() : Document
    {
      	return this.$store.getters.document;
    }

    public get currentPage() : Page
    {
        if(this.currentDocument.useInsertion)
        {
            return this.insertionPage != null ? this.insertionPage : this.currentDocument.pageList[0];
        }
        else
        {
            return this.currentDocument.pageList[this.currentDocument.currentPageIndex];
        }
    }

    private get isReverseSurface()
    {
        var document = this.currentDocument;
        return document.isReverseSurface;
    }

    private get bleedSize()
    {
        return this.$store.getters.userConfig.bleedSize;
    }

    public get currentPageNumber() : number
    {
        return this.currentDocument.currentPageIndex + 1;
    }

    private get documentRotate() : number
    {
        return this.currentDocument.rotate;
    }

	// すべてのドキュメントへの編集は、このクラスから行う
	// action - mutation モデルへの移行も視野に入れている

	// コマンドのコール
	private onDoCommand(command : string, parameter : any)
	{
        if(command == "selectDesign")
        {
            // デザインの選択
            this.selectDesign(parameter.position);
        }
        else if(command == "goPage")
        {
            // ページ変更
            this.goPage(parameter.page);
        }
        else if(command == "saveDocument")
        {
            // ドキュメントを保存
            this.saveDocument();
        }
        else if(command == "copyVertical")
        {
            // 縦一列にデザインをコピー
            this.copyVertical();
        }
        else if(command == "copyHorizontal")
        {
            // 横一列にデザインをコピー
            this.copyHorizontal();
        }
        else if(command == "copyAll")
        {
            // 全面にデザインをコピー
            this.copyAll();
        }
        else if(command == "addPage")
        {
            // ページを追加
            this.addPage();
        }
        else if(command == "deletePage")
        {
            // ページを削除
            this.deletePage();
        }
        else if(command == "createDesign")
        {
            // 新規デザイン
            this.createDesign();
        }
        else if(command == "deleteAll")
        {
            // 全デザイン削除
            this.showDeleteDesignModal();
            this.deleteDesignIndex = -1;
            this.deleteUnselectDesigns = false;

        }
        else if(command == "deleteDesign")
        {
            // デザイン削除
            this.showDeleteDesignModal();
            this.deleteDesignIndex = this.currentPage.currentDesignPosition;
            this.deleteUnselectDesigns = false;
        }
        else if(command == "deleteUnselect")
        {
            // 選択外のデザインを削除
            this.showDeleteDesignModal();
            this.deleteDesignIndex = this.currentPage.currentDesignPosition;
            this.deleteUnselectDesigns = true;
        }
        else if(command == "moveDesign")
        {
            // デザイン移動
            this.moveDesign(parameter.from, parameter.to);
        }
        else if(command == "saveDocument")
        {
            // 印刷ファイル保存
            this.saveDocument();
        }
        else if(command == "goNext")
        {
            // 次へ
            this.goNext();
        }
        else if(command == "changeSurface")
        {
            // 表面、裏面変更
            this.changeSurface(parameter.isReverse);
        }
        else if(command == "showContextMenu")
        {
            // コンテキストメニュー表示
            this.showContextMenu(parameter.event);
        }
        else if(command == "changeZoomScale")
        {
            // ズーム倍率変更
            var isAutoZoomOff = (parameter.isAutoZoomOff != null) ? parameter.isAutoZoomOff : false;
            this.changeZoomScale(parameter.scale, isAutoZoomOff);
        }
        else if(command == "changeAutoZoom")
        {
            // 自動ズーム切り替え
            this.changeAutoZoom(parameter.isAutoZoom);
        }
        else if(command == "undo")
        {
            // アンドゥ
            this.undo();
        }
        else if(command == "redo")
        {
            // リドゥ
            this.redo();
        }
        else if(command == "changeUserConfig")
        {
            // ユーザー設定変更
            this.changeUserConfig(parameter.propertyName, parameter.value);
        }
        else if(command == "rotateDocument")
        {
            // ドキュメントの回転
            this.rotateDocument(parameter.delta);
        }
        else if(command == "loadDocument")
        {
            // ドキュメントのロード
            this.loadDocument();
        }
        else if(command == "startDragDesign")
        {
            // デザインのドラッグを開始する
            this.draggingItemPosition = parameter.position;
        }
        else if(command == "endDragDesign")
        {
            // デザインのドラッグを終了する
            this.draggingItemPosition = -1;
        }
        else if(command == "dropOutside")
        {
            // 外側にドロップする
            if(0 <= this.draggingItemPosition && this.draggingItemPosition < this.currentPage.designMaxNumber)
            {

                this.showDeleteDesignModal()
                this.deleteDesignIndex = this.draggingItemPosition;
                this.deleteUnselectDesigns = false;
            }
        }
        else if(command == "dropToDesign")
        {
            // デザインにドロップする
            var to = parameter.position;
            if(0 <= to && to < this.currentPage.designMaxNumber)
            {
                if(0 <= this.draggingMaterialIndex)
                {
                    // 素材のドロップ
                    this.dropDesignMaterial(this.draggingMaterialIndex, to);
                }
                if(0 <= this.draggingItemPosition && this.draggingItemPosition < this.currentPage.designMaxNumber)
                {
                    // 移動
                    this.moveDesign(this.draggingItemPosition, to);
                }
            }
        }
        else if(command == "startDragMaterial")
        {
            // デザイン素材のドラッグ開始
            this.draggingMaterialIndex = parameter.index;
        }
        else if(command == "endDragMaterial")
        {
            // デザイン素材のドラッグ終了
            this.draggingMaterialIndex = -1;
        }
        else if(command == "setOffset")
        {
            // 差し込み開始面変更
            this.setOffset(parameter.offset);
        }
        else if(command == "setStartRow")
        {
            // 開始行変更
            this.setStartRow(parameter.row);
        }
        else if(command == "setEndRow")
        {
            // 終了行変更
            this.setEndRow(parameter.row);
        }
        else if(command == "setPrintCount")
        {
            // 差し込み印刷枚数変更
            this.setPrintCount(parameter.count);
        }
        else if(command == "setInsertionDirection")
        {
            // 差し込み方向変更
            this.setInsertionDirection(parameter.direction);
        }
    }

    // デザインの選択
    private selectDesign(position : number)
    {
        // アンドゥ・リドゥの対象外
        this.currentPage.currentDesignPosition = position;
    }

    // ページの移動
    private goPage(page : number)
    {
        // アンドゥ・リドゥの対象外
        if(page < 0 || this.maxPage <= page) { return; }
        this.currentDocument.currentPageIndex = page;

        // 差し込みページ更新
        if(this.currentDocument.useInsertion) this.updatePage();
    }

    // デザインの複製
    private duplicateDesign(isHorizontal : boolean, isVertical : boolean)
    {
        var command = new DuplicateDesignCommand(this.currentPage.currentDesignPosition, this.currentPage, this.isReverseSurface, isHorizontal, isVertical, () => {});
        this.currentDocument.undoRedoManager.do(command);
    }

    // 縦一列にデザインをコピー
    private copyVertical(isClipboard = false, doCommand : boolean = true)
    {
        // 現在のドキュメントから縦一列にあるpositionを得る
        var targetPositionArray = this.currentDocument.getVerticalPositionArray(this.currentPage.currentDesignPosition);
        return this.copyDesignCore(isClipboard, targetPositionArray, doCommand);
    }

    // 横一列にデザインをコピー
    private copyHorizontal(isClipboard = false, doCommand = true)
    {
        // 現在のドキュメントから横一列にあるpositionを得る
        var targetPositionArray = this.currentDocument.getHorizontalPositionArray(this.currentPage.currentDesignPosition);
        return this.copyDesignCore(isClipboard, targetPositionArray, doCommand);
    }

    // 全面にデザインをコピー
    private copyAll(isClipboard = false, doCommand : boolean = true)
    {
        // 現在のドキュメントから全面にあるpositionを得る
        var targetPositionArray = this.currentDocument.getFramePositionArray(this.currentPage.currentDesignPosition);
        return this.copyDesignCore(isClipboard, targetPositionArray, doCommand);
    }

    // デザインコピーメイン処理
    private copyDesignCore(isClipboard, targetPositionArray : Array<number>, doCommand : boolean = true)
    {
        let result = false;
        if(targetPositionArray.length >= 1)
        {
            // 現在選択中のデザイン。クリップボードからの場合はクリップボード
            let surface = this.currentPage.getSurface(this.isReverseSurface);
            let design = isClipboard ? this.clipboardManager.getAsDesign() : surface.getDesign(this.currentPage.currentDesignPosition);
            if(!isClipboard || design != null) {
                // クリップボードにデザインがない場合 -> 無効
                // それ以外は続行
                var fixPositionArray : Array<number> = [];
                for(let i = 0; i < targetPositionArray.length; ++i)
                {
                    // クリップボードではない場合、ターゲットが自身の場合はコピーしない。
                    if(!isClipboard && this.currentPage.currentDesignPosition == targetPositionArray[i]) { continue; }
                    fixPositionArray.push(targetPositionArray[i]);
                }
                if(fixPositionArray.length > 0)
                {
                    if(design != null)
                    {
                        if(doCommand)
                        {
                            // 対象デザインがある場合はコピーする
                            let startCallback = () =>
                            {
                                // コピー開始
                                this.isWaiting = true;
                            };
                            let finishCallback = () =>
                            {
                                // コピー終了
                                this.isWaiting = false;
                            };
                            let command = new CopyMultiDesignCommand(design, surface, fixPositionArray, startCallback, finishCallback)
                            this.currentDocument.undoRedoManager.do(command);
                        }
                        result = true;
                    } else {
                        // 対象デザインがない場合は削除する
                        for(let index of fixPositionArray)
                        {
                            let design = surface.getDesign(index);
                            if(design != null)
                            {
                                if(doCommand)
                                {
                                    let command = new DeleteDesignCommand(index, this.currentPage, this.isReverseSurface, () => {});
                                    this.currentDocument.undoRedoManager.doAsMultiCommand(command);
                                }
                                result = true;
                            }
                        }
                        if(doCommand && result)
                        {
                            this.currentDocument.undoRedoManager.fixMultiCommand();
                        }
                    }
                }
            }
        }

        return result;
    }

    // ページを今のページの次に追加
    private addPage()
    {
        // ページ最大数チェック
        if(this.currentDocument.pageCount >= Const.MAX_PAGE_NUMBER)
        {
            DebugHelper.trace("ページ最大数");
            return;
        }

        var command = new NewPageCommand(this.currentDocument.currentPageIndex + 1, this.currentDocument, () => {});
        this.currentDocument.undoRedoManager.do(command);
    }

    // 現在のページを削除
    private deletePage()
    {
        // 残りページが1ページの場合は消せない
        if(this.currentDocument.pageList.length <= 1) { return; }

        var command = new DeletePageCommand(this.currentDocument.currentPageIndex, this.currentDocument, () => {});
        this.currentDocument.undoRedoManager.do(command);
    }

    // 新規デザイン
    private createDesign()
    {
        if(this.currentDocument.useInsertion)
        {
            // 差し込みの場合は、強制的に最初のページの最初のデザインを開くことになる
            this.goLink("/DesignEditor", true, () =>
            {
                this.currentDocument.currentPageIndex = 0;
                this.currentDocument.pageList[0].currentDesignPosition = 0;
            });
            return;
        }
        // すでにデザインが存在している場合は新規作成しない
        if(this.currentPage.getSurface(this.isReverseSurface).getDesign(this.currentPage.currentDesignPosition) != null)
        {
            // デザインエディターに遷移
            this.goLink("/DesignEditor", true);
            return;
        }

        // 強制的に空白のデザインを作成する
        this.currentPage.getSurface(this.isReverseSurface).createNewDesign(this.currentPage.currentDesignPosition);
        // テンプレート選択に遷移
        this.goLink("/SelectTemplate", false);
    }

    // 次へ
    private goNext()
    {
        // 印刷設定画面へ
        this.goLink("/PrintSetting", true);
    }

    // カレントデザインをカット
    private cutCurrentDesign(doCommand : boolean = true)
    {
        var result = false;
        var currentDesign = this.currentPage.getSurface(this.isReverseSurface).getDesign(this.currentPage.currentDesignPosition);
        if(currentDesign != null)
        {
            if(doCommand)
            {
                // クリップボードへコピー
                this.clipboardManager.copy(currentDesign.clone());
                // 削除
                this.deleteDesign(this.currentPage.currentDesignPosition);
            }
            result = true;
        }
        return result;
    }

    // カレントデザインをコピー
    private copyCurrentDesign(doCommand : boolean = true)
    {
        return this.copyDesign(this.currentPage.getSurface(this.isReverseSurface).getDesign(this.currentPage.currentDesignPosition), doCommand);
    }

    // デザインをクリップボードにコピー
    private copyDesign(design, doCommand : boolean = true)
    {
        var result = false;
        if(design != null)
        {
            // クリップボードにコピー
            if(doCommand)
            {
                this.clipboardManager.copy(design.clone());
            }
            result = true;
        }
        return result;
    }

    // デザインをカレントへ貼り付け
    private pasteDesignToCurrent(doCommand : boolean = true)
    {
        return this.pasteDesign(this.currentPage.currentDesignPosition, doCommand);
    }

    // デザインをクリップボードから貼り付け
    private pasteDesign(position, doCommand : boolean = true)
    {
        var targetPositionArray = [position];
        return this.copyDesignCore(true, targetPositionArray, doCommand);
    }

    // 全デザインを削除
    private deleteAllDesign(doCommand : boolean = true)
    {
        var result = false;
        for(var i = 0; i < this.currentPage.designMaxNumber; ++i)
        {
            var design = this.currentPage.getSurface(this.isReverseSurface).getDesign(i);
            if(design != null)
            {
                if(doCommand)
                {
                    var command = new DeleteDesignCommand(i, this.currentPage, this.isReverseSurface, () => {});
                    this.currentDocument.undoRedoManager.doAsMultiCommand(command);
                }
                result = true;
            }
        }

        if(result && doCommand)
        {
            this.currentDocument.undoRedoManager.fixMultiCommand();
        }

        return result;
    }

    // デザインを削除
    private deleteDesign(position, doCommand : boolean = true)
    {
        var result = false;
        var design = this.currentPage.getSurface(this.isReverseSurface).getDesign(position);
        if(design != null)
        {
            if(doCommand)
            {
                var command = new DeleteDesignCommand(position, this.currentPage, this.isReverseSurface, () => {});
                this.currentDocument.undoRedoManager.do(command);
            }
            result = true;
        }
        return result;
    }

    // デザインを複数削除
    private deleteMultiDesigns(positions : Array<number>, doCommand : boolean = true)
    {
        let result = false;
        let surface = this.currentPage.getSurface(this.isReverseSurface);
        for(let position of positions)
        {
            let design = surface.getDesign(position);
            if(design != null)
            {
                let command = new DeleteDesignCommand(position, this.currentPage, this.isReverseSurface, () => {});
                this.currentDocument.undoRedoManager.doAsMultiCommand(command);
                result = true;
            }
        }
        if(result && doCommand)
        {
            this.currentDocument.undoRedoManager.fixMultiCommand();
        }
        return result;
    }

    // デザインを移動
    private moveDesign(from : number, to : number, doCommand : boolean = true)
    {
        var result = false;

        if(from != to)
        {
            var fromDesign = this.currentPage.getSurface(this.isReverseSurface).getDesign(from);
            var toDesign = this.currentPage.getSurface(this.isReverseSurface).getDesign(to);
            if(fromDesign != null)
            {
                if(doCommand)
                {
                    // コピー
                    var copyCommand = new CopyDesignCommand(fromDesign, to, this.currentPage, this.isReverseSurface, () => {});
                    this.currentDocument.undoRedoManager.doAsMultiCommand(copyCommand, false);
                    // 削除
                    var deteteCommand = new DeleteDesignCommand(from, this.currentPage, this.isReverseSurface, () => {});
                    this.currentDocument.undoRedoManager.doAsMultiCommand(deteteCommand, true);

                    // カレントを移動先にする
                    this.currentPage.currentDesignPosition = to;
                }
                result = true;
            }
        }
        return result;
    }

    // デザインを素材から貼り付け
    private dropDesignMaterial(index : number, to : number, doCommand : boolean = true)
    {
        var result = false;
        var designMaterials = this.$store.getters.userConfig.designMaterials;
        if(0 <= index && index < designMaterials.length)
        {
            var matrial = designMaterials[index];
            var toDesign = this.currentPage.getSurface(this.isReverseSurface).getDesign(to);

            if(doCommand)
            {
                var command = new CopyDesignCommand(matrial, to, this.currentPage, this.isReverseSurface, () => {});
                this.currentDocument.undoRedoManager.do(command);

                // カレントを移動先にする
                this.currentPage.currentDesignPosition = to;
            }
            result = true;
        }

        return result;
    }

    // デザインを編集
    private editDesign()
    {
        this.createDesign();
    }

    // 表面・裏面変更
    private changeSurface(isReverse : boolean)
    {
        this.currentDocument.setSurface(isReverse);
    }

    // コンテキストメニュー表示
    private showContextMenu(event)
    {
        var contextMenu = this.$refs.menu as ContextMenu;
        if(contextMenu != null)
        {
            // menuItems
            var menuItems = new Array();
            var currentDesign = this.currentPage.getSurface(this.isReverseSurface).getDesign(this.currentPage.currentDesignPosition);
            menuItems.push({ text : "コピー", isEnable : this.copyDesign(currentDesign, false),  callback : () => { this.copyDesign(currentDesign); } });
            menuItems.push({ text : "貼り付け", isEnable : this.pasteDesign(this.currentPage.currentDesignPosition, false), callback : () => { this.pasteDesign(this.currentPage.currentDesignPosition); } });
            // menuItems.push({ text : "削除", isEnable : this.deleteDesign(this.currentPage.currentDesignPosition, false),  callback : () => { this.deleteDesignModalActive("deleteDesign" , {position : this.currentPage.currentDesignPosition}) } });
            menuItems.push({ text : "縦一列にコピー", isEnable : this.copyVertical(false, false),  callback : () => { this.copyVertical(); } });
            menuItems.push({ text : "横一行にコピー", isEnable : this.copyHorizontal(false, false),  callback : () => { this.copyHorizontal(); } });
            menuItems.push({ text : "ページ全体にコピー", isEnable : this.copyAll(false, false), callback : () => { this.copyAll(); } });
            if(this.copyDesign(currentDesign, false)){
                menuItems.push({ text : "デザイン編集" , isEnable : true, callback : () => this.editDesign() });
            }else{
                menuItems.push({ text : "デザイン作成" , isEnable : true, callback : () => this.editDesign() });
            }
            menuItems.push({ text : "削除", isEnable : true, callback : () => {
                this.showDeleteDesignModal();
                this.deleteDesignIndex = this.currentPage.currentDesignPosition;
                this.deleteUnselectDesigns = false;
            }});
            menuItems.push({ text : "選択面以外を削除", isEnable : true, callback : () => {
                this.showDeleteDesignModal();
                this.deleteDesignIndex = this.currentPage.currentDesignPosition;
                this.deleteUnselectDesigns = true;
            }});
            contextMenu.open(event, menuItems);
        }
    }

    // ズーム倍率変更
    private changeZoomScale(scale, isAutoZoomOff)
    {
        this.zoomScale = scale;

        // オートズーム解除
        if(isAutoZoomOff && this.isAutoZoom) { this.isAutoZoom = false; }
    }

    // ズーム倍率のステップ変更
    private changeZoomScaleByStep(up : boolean, isAutoZoomOff : boolean, doCommand : boolean = true) : boolean
    {
        var result = false;
        if(up)
        {
            // 最大ズームサイズチェック
            if(this.zoomScale < Const.CANVAS_ZOOM_MAX)
            {
                if(doCommand)
                {
                    // ズームサイズを+25
                    var newZoomScale = this.zoomScale + 25;
                    if(newZoomScale > Const.CANVAS_ZOOM_MAX) { newZoomScale = Const.CANVAS_ZOOM_MAX; }
                    this.zoomScale = newZoomScale;

                    // オートズーム解除
                    if(isAutoZoomOff && this.isAutoZoom) { this.isAutoZoom = false; }
                }
                result = true;
            }
        }
        else
        {
            // 最小ズームサイズチェック
            if(this.zoomScale > Const.CANVAS_ZOOM_MIN)
            {
                if(doCommand)
                {
                    // ズームサイズを-25
                    var newZoomScale = this.zoomScale - 25;
                    if(newZoomScale < Const.CANVAS_ZOOM_MIN) { newZoomScale = Const.CANVAS_ZOOM_MIN; }
                    this.zoomScale = newZoomScale;

                    // オートズーム解除
                    if(isAutoZoomOff && this.isAutoZoom) { this.isAutoZoom = false; }
                }
                result = true;
            }
        }

        return result;
    }

    // 自動ズーム切り替え
    private changeAutoZoom(isAutoZoom)
    {
        this.isAutoZoom = isAutoZoom;
    }

    // ズーム自動切り替え
    private switchAutoZoom(doCommand = true)
    {
        if(doCommand)
        {
            this.isAutoZoom = !this.isAutoZoom;
        }
        return true;
    }

    // アンドゥ
    private undo()
    {
        if(this.currentDocument.undoRedoManager.canUndo)
        {
            this.currentDocument.undoRedoManager.undo();
        }
    }

    // リドゥ
    private redo()
    {
        if(this.currentDocument.undoRedoManager.canRedo)
        {
            this.currentDocument.undoRedoManager.redo();
        }
    }

    // ユーザー設定変更
    private changeUserConfig(propertyName : string, value : any)
    {
        var userConfig = this.$store.getters.userConfig;
        if(userConfig != null)
        {
            if(userConfig[propertyName] != null)
            {
                userConfig[propertyName] = value;
            }
        }
    }

    // ドキュメントの回転
    private rotateDocument(delta : number)
    {
        var command = new RotateDocumentCommand(this.currentDocument, delta, () => {});
        this.currentDocument.undoRedoManager.do(command);
    }

    // 印刷ファイル保存
    private saveDocument()
    {
        if(UserAgentHelper.isElectron())
        {
            // DL版はネイティブで保存する
            NativeHelper.sendNativeEvent("request_save_as_document", {});
            return;
        }

        var comp = () =>
        {
            // 開いた時のファイル名があればそれを使う
            var fileName = this.currentDocument.openedFileName != "" ? FileHelper.getFilenameWithoutExtension(this.currentDocument.openedFileName) : NameHelper.createNewDocumentFileName(this.currentDocument);
            FileHelper.saveDocumentAsZip(this.currentDocument, fileName);
            this.sendSaveLog();
        };

        var alert = this.$refs.saveAttentionAlert as SaveAttentionAlert;
        if(alert.isAvailable())
        {
            // モーダルを開き、OKを押したときにセーブ
            alert.open(comp);
        }
        else
        {
            comp();
        }
    }

    // 履歴送信
    private sendSaveLog()
    {
        var logValue = {
            productId : this.currentDocument.productId,
            code : this.currentDocument.paperCode,
            templateId : this.$store.getters.data.selectedTemplate.id,
            cloud : 0
        }

        LogHelper.sendLog("1000", logValue);
    }

    // ページ数
    public get maxPage() : number
    {
        if(this.currentDocument.useInsertion)
        {
            return this.insertionMaxPage;
        }
        else
        {
            return this.currentDocument.pageList.length;
        }
    }

    // ドキュメントのロード
    // ライトコントローラに貼り付け用のデザインをセットする
    // 通常は全デザイン(オブジェクト存在のみ)
    // 差し込みは第１デザイン
    private loadDocument()
    {
        var fileOpen = this.$refs.fileOpen2 as FileOpen2;
        fileOpen.open(FileOpen2.FILETYPE_DOCUMENT, args => 
        {
            var doc : Document | null = null;
            // 拡張子で振り分ける
            var ext = FileHelper.getFileExtension(args.fileName);
            if(ext == "lcx" || ext == "lcxt")
            {
                // Label9形式
                doc = FileHelper.loadDocumentFromLabel9(args.data, this.$store.getters.fontManager);
            }
            else
            {
                // 通常形式
                doc = FileHelper.loadDocument(args.data);
            }

            if(doc == null) return;

            var completion = () =>
            {
                if(doc == null) { return; }

                // Documentからデザインを取得していき、素材に追加する
                var designMaterials = ArrayHelper.clone(this.$store.getters.userConfig.designMaterials);
                for(var pageIndex = 0; pageIndex < doc.pageCount; ++pageIndex)
                {
                    var page = doc.pageList[pageIndex];
                    var surfaceCount = page.hasReverse ? 2 : 1;
                    for(var surfaceIndex = 0; surfaceIndex < surfaceCount; ++surfaceIndex)
                    {
                        var surface = page.getSurface(surfaceIndex > 0);
                        for(var i = 0; i < page.designMaxNumber; ++i)
                        {
                            var design = surface.getDesign(i);
                            if(design != null && design.hasAnyObject(true))
                            {
                                // オブジェクトが存在していれば追加する
                                designMaterials.push(design);
                            }
                        }
                    }
                }
                // セット
                this.$store.getters.userConfig.designMaterials = designMaterials;
            };

            var isFontConvertModalVisible = false;
            if(doc.unloadedFonts.length > 0)
            {
                // 利用できないフォントがあった場合
                var fontConvertModal = this.$refs.fontConvertModal as FontConvertModal;
                if(fontConvertModal != null)
                {
                    // フォントモーダルを開き、OKが押されたときにドキュメントロードする
                    isFontConvertModalVisible = true;
                    fontConvertModal.open(doc.unloadedFonts, completion);
                }
            }

            if(!isFontConvertModalVisible)
            {
                // フォントモーダルを出さない場合はそのままドキュメントロード
                completion();
            }
        });
    }

    private loadDocumentCore(document : Document | null)
    {
        if(document == null) { return; }

        // Documentからデザインを取得していき、素材に追加する
        var designMaterials = ArrayHelper.clone(this.$store.getters.userConfig.designMaterials);
        for(var pageIndex = 0; pageIndex < document.pageCount; ++pageIndex)
        {
            var page = document.pageList[pageIndex];
            var surfaceCount = page.hasReverse ? 2 : 1;
            for(var surfaceIndex = 0; surfaceIndex < surfaceCount; ++surfaceIndex)
            {
                var surface = page.getSurface(surfaceIndex > 0);
                for(var i = 0; i < page.designMaxNumber; ++i)
                {
                    var design = surface.getDesign(i);
                    if(design != null && design.hasAnyObject(true))
                    {
                        // オブジェクトが存在していれば追加する
                        designMaterials.push(design);
                    }
                }
            }
        }
        // セット
        this.$store.getters.userConfig.designMaterials = designMaterials;
    }

    // Product, Pageの選択情報を更新する
    private updateProductAndPageDataFromDocument(document : Document, completion : () => void)
    {
        InitializeHelper.getProductAndPaperFromPaperCode(this.$store.getters.data.productCategoryList, document.paperCode, (product : Product, paper : Paper, categoryId : number, hierarchy : number) =>
        {
            // アプリ全体の用紙選択情報を更新する
            this.$store.getters.data.selectedProduct = product;
            this.$store.getters.data.selectedPaper = paper;
            this.$store.getters.data.paperDirection = Math.round(document.rotate / 90);
            this.$store.getters.data.selectTemplateCategory(categoryId, hierarchy);

            completion();
        }, () =>
        {
            completion();
        });
    }

    private createDocumentFromFileText(text) : Document
    {
        var compositeText = EncryptionHelper.compositeIfNeeded(text);
        var jsonData = JSON.parse(compositeText);
        var document = Document.createFromJsonData(jsonData);
        return document;
    }

    private createDocumentFromLabel9FileText(text) : Document | null
    {
        var fileConverter = new FileConverter(this.$store.getters.fontManager);
        var document = fileConverter.deserializeLabel9FromXml(text);
        return document;
    }

    private isDeleteDesignModalVisible = false;
    private deleteDesignIndex = -1;
    private deleteUnselectDesigns = false;

    showDeleteDesignModal()
    {
        this.isDeleteDesignModalVisible = true;
    }

    deleteDesignModalCallback()
    {

        if(this.deleteDesignIndex < 0)
        {
            this.deleteAllDesign();
        }
        else
        {
            if(this.deleteUnselectDesigns)
            {
                let positions : Array<number> = [];
                for(let i = 0; i < this.currentPage.designMaxNumber; ++i)
                {
                    if(i != this.deleteDesignIndex)
                    {
                        // 選択デザイン以外を削除対象に追加
                        positions.push(i);
                    }
                }
                this.deleteMultiDesigns(positions);
            }
            else
            {
                this.deleteDesign(this.deleteDesignIndex)
            }
        }
    }

    get flowMode(){
        return this.$store.getters.applicationState.flowMode;
    }

    // 差し込み開始面変更
    private setOffset(offset : number)
    {
        this.currentDocument.insertionData.offset = offset;
        // 差し込みページ更新
        if(this.currentDocument.useInsertion) this.updatePage();
    }

    // 差し込み開始行変更
    private setStartRow(row : number)
    {
        this.currentDocument.insertionData.startRow = row;
        // 差し込みページ更新
        if(this.currentDocument.useInsertion) this.updatePage();
    }

    // 差し込み終了行変更
    private setEndRow(row : number)
    {
        this.currentDocument.insertionData.endRow = row;
        // 差し込みページ更新
        if(this.currentDocument.useInsertion) this.updatePage();
    }

    // 差し込み枚数変更
    private setPrintCount(count : number)
    {
        this.currentDocument.insertionData.printCount = count;
        // 差し込みページ更新
        if(this.currentDocument.useInsertion) this.updatePage();

    }

    // 差し込み方向変更
    private setInsertionDirection(direction : number)
    {
        this.currentDocument.insertionData.insertionDirection = direction;
        // 差し込みページ更新
        if(this.currentDocument.useInsertion) this.updatePage();
    }

    // 新規ドキュメント
    private isSaveModalVisible = false;
    private saveModalCompletion = () => {};
    private createNewDocument(doCommand = true)
    {
        if(doCommand)
        {
            let completion = () =>
            {
                // フローを通常にする
                this.$store.getters.applicationState.flowMode == 0;

                // 用紙選択に遷移
                this.$router.push("/SelectPage");
            }

            // TODO 本来は編集フラグを見ること。
            if(true)
            {
                // 保存させるか選択するモーダルを表示する
                this.isSaveModalVisible = true;
                // 完了時の処理
                this.saveModalCompletion = () =>
                {
                    completion();
                };
            }
            else
            {
                completion();
            }
        }

        return true;
    }

    // 保存モーダルのコールバック
    private saveModalCallback(button : string)
    {
        if(button == "save")
        {
            this.saveDocument();
        }

        // 完了処理
        this.saveModalCompletion();
    }

    //選択中用紙
    get selectedPaper(){
        return this.$store.getters.data.selectedPaper
    }

    private closeLicense(){
        this.isLicense = false;
        if(this.flowMode == 0){
            this.isTutorial = CookieHelper.getItem("layoutEditorTutorial") != true;
        }
        else if(this.flowMode == 1 || this.flowMode == 2){
            this.isTutorial = CookieHelper.getItem("insertionLayoutEditorTutorial") != true;
        }
    }

    /* 広告 */

    banners: RecommendBannerProps[] = [];

    clickRecommendBanner(key: string) {
        const api = new RecommendApi();
        const uuid = CookieHelper.hasItem("authorizationToken") ? CookieHelper.getItem("authorizationToken") : "";
        const platformId = String(platform.id);
        api.log(key, uuid, platformId);
    }

    private loadRecommendBanners() {
        const api = new RecommendApi();
        const uuid = CookieHelper.hasItem("authorizationToken") ? CookieHelper.getItem("authorizationToken") : "";
        const platformId = String(platform.id);
        api.top(uuid, platformId).then(recommends => {
            this.banners = recommends.map(r => ({
                key: String(r.id),
                url: r.url,
                image: r.image
            }));
        })
    }
}

